/**
 * Query param carrying the backend worktree between apps (local dev only). An empty value means
 * "no worktree" and clears any stored override.
 */
export const WORKTREE_QUERY_PARAM = 'x-worktree';
